export default __webpack_public_path__ + "static/media/IMG-20241005-WA0018.1b7cec81.jpg";